import { useTranslation } from "react-i18next";
import EnglishFlag from "../../assets/icons/EnglishFlag";
import GermanFlag from "../../assets/icons/GermanFlag";

const LanguageSwitcherComponent = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (language: string) => {
    void i18n.changeLanguage(language);
    // Store the selected language in localStorage
    localStorage.setItem("i18nextLng", language);
  };

  return (
    <div className="language-switcher">
      <button
        type="button"
        className={`language-btn ${i18n.language === "en" ? "active-language" : "language-item"}`}
        onClick={() => handleLanguageChange("en")}
        aria-label="Switch to English"
      >
        <span className="language-text">EN</span>
        <EnglishFlag />
      </button>
      <button
        type="button"
        className={`language-btn ${i18n.language === "de" ? "active-language" : "language-item"}`}
        onClick={() => handleLanguageChange("de")}
        aria-label="Switch to German"
      >
        <span className="language-text">DE</span>
        <GermanFlag />
      </button>
    </div>
  );
};

export default LanguageSwitcherComponent;
